// setting
export const ADD_SETTING = 'ADD_SETTING';
export const REMOVE_SETTING = 'REMOVE_SETTING';
export const EMPTY_SETTING = 'EMPTY_SETTING';
